module.exports = __webpack_public_path__ + "img/AuditedFinancials.9100b1be.png";